import { Divider, Stack, SxProps } from '@mui/material';
import { ControlledDropdown } from 'Components/ControlledDropdown';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { SubjectType } from './SubjectType';
import { OrderByDate } from './OrderByDate';
import { ArrowBackWhite } from 'Images';
import { DatePeriod } from './DatePeriod';
import { useContext } from 'react';
import { DocumentsContext } from 'Context/DocumentsContext';

export const AdvancedFilter = () => {
  const { filter, documents } = useContext(DocumentsContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);

  const divider = (
    <Divider
      orientation='vertical'
      sx={{ borderColor: '#B7CCFF', height: '47px', m: '0 20px' }}
    />
  );
  const btnStyle: SxProps = {
    border: 'none',
    gap: '16px',
    borderRadius: '10px',
    ':hover': {
      bgcolor: '#A020FF',
      color: '#FFF',
    },
  };
  const selectedBtnStyle: SxProps = {
    bgcolor: '#1552E8',
    color: '#FFF',
  };
  const menuStyle: SxProps = {
    borderRadius: '10px',
  };

  const dateOptions = Object.keys(filter.datePeriod).map(
    (key, index: number) => ({
      key,
      label: dictionary.datePeriodOptions[index],
      value: (filter.datePeriod as any)[key],
    })
  );
  const selectedDateOptions = dateOptions.filter((option) => option.value);

  const allDocs = [
    ...documents.results.todayDocs,
    ...documents.results.thisWeekDocs,
    ...documents.results.thisMonthDocs,
    ...documents.results.thisYearDocs,
    ...documents.previousYearsResults,
  ];

  // Extract unique subject names, count their occurrences in the docs, and sort them in descending order by count (most frequent first).
  const subjectTypeOptions: string[] = [
    ...new Set(allDocs.map((doc) => doc.subjectName)),
  ]
    .reduce<string[]>((acc, subjectName) => {
      const count = allDocs.filter(
        (doc) => doc.subjectName === subjectName
      ).length;
      acc.push(`${subjectName} (${count})`);
      return acc;
    }, [])
    .sort((a, b) => {
      const countA = parseInt(a.match(/\((\d+)\)/)?.[1] || '0');
      const countB = parseInt(b.match(/\((\d+)\)/)?.[1] || '0');
      return countB - countA;
    });

  return (
    <Stack
      direction='row'
      alignItems='center'
      sx={{
        width: 'fit-content',
      }}
    >
      <ControlledDropdown
        label={
          filter.subjectsTypes.length === 0
            ? dictionary.subjectType
            : filter.subjectsTypes.length === 1
            ? filter.subjectsTypes[0]
            : dictionary.multiSubject(filter.subjectsTypes.length)
        }
        filterComponent={<SubjectType options={subjectTypeOptions} />}
        button={
          filter.subjectsTypes.length > 0
            ? {
                sx: { ...btnStyle, ...selectedBtnStyle },
                buttonImageSrc: ArrowBackWhite,
              }
            : {
                sx: btnStyle,
                buttonHoverImageSrc: ArrowBackWhite,
              }
        }
        menuPaper={{
          sx: menuStyle,
        }}
        hideLine
      />
      {divider}
      <ControlledDropdown
        label={
          selectedDateOptions.length === 0
            ? dictionary.datePeriod
            : selectedDateOptions.length === 1
            ? selectedDateOptions[0].label
            : dictionary.multiDatePeriods(selectedDateOptions.length)
        }
        filterComponent={<DatePeriod options={dateOptions} />}
        button={
          selectedDateOptions.length > 0
            ? {
                sx: { ...btnStyle, ...selectedBtnStyle },
                buttonImageSrc: ArrowBackWhite,
              }
            : {
                sx: btnStyle,
                buttonHoverImageSrc: ArrowBackWhite,
              }
        }
        menuPaper={{
          sx: menuStyle,
        }}
        hideLine
      />
      {divider}
      <OrderByDate />
    </Stack>
  );
};
